import { SafeJSON } from '../shared/safe-json';

export class CivilIdentiyAdditionalDetails  {
   json: any;
   errorMsg: string;
   constructor(json: any) {
       this.json = json;
   }

   getPartyEntryTime(): string {
      return SafeJSON.get('entTs', this.json);
   }
   getPartyNumber(): number {
      return SafeJSON.get('partyNumber', this.json);
   }
   getPartyRole(): string {
     return SafeJSON.get('partyRole', this.json);
   }
   getNameType(): string {
     return SafeJSON.get('nameType', this.json);
   }
   getOtherEntryTime() {
     return SafeJSON.get('otherEntTs', this.json);
   }

   getInRegardsTo(): any {
    return this.json.inRegardsTo;
   }

   getIndexedJudgment(): any {
     return this.json.indexedJudgment;
   }

   getMessages(): string {
     if (this.json.messages && this.json.messages.length !== 0 ) {
       let messageText = this.json.messages.map(messageItem =>
        (messageItem.key + ': ' + messageItem.message)).join();

       return messageText;
     }
     return null;
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-identity-additional-details.ts